import { BaseDtoModel } from '../../base-dto.model';

export class ReportModel extends BaseDtoModel {

    reportParameters: ReportObject = new ReportObject();

}

// SENHENG_SUPPLIER_DELIVERY_ORDER_LISTING_REPORT
// SENHENG_CONSOLIDATE_PO_REPORT
// reportOutputFormat : PDF or HTMLq
export class GeneralReportModel extends BaseDtoModel {
  reportParameters: any;
}

export class ReportObject {
  reportCode = '';
  reportOutputFormat = '';
  poGuid = '';
  reportUrl = '';
}
